import script from "./DbSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./DbSelect.vue?vue&type=script&setup=true&lang=ts"

import "./DbSelect.vue?vue&type=style&index=0&id=58e82b92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e82b92"]])

export default __exports__